module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAPFBMVEUAAADm5ubj4+Ph4eHj4+Pl5eXm5ubl5eXl5eXm5ubl5eXl5eXk5OTl5eXl5eXm5ubl5eXn5+f////l5eUrn+2mAAAAE3RSTlMAv4ArZdnKf+7flYnAsXRIPDUCi4FzIQAAAGVJREFUOMvt0LsOwCAIQFHBqlX75v//tSYmxAFo0tk7uHgSBdcqpFRcDzQADAARE/aDgxE4oQkmkEGksAgFBisp5S8Q+LHohaL4ydPbUxxElwk2omSCO+/Pv02i0AjkGFQN1Hb5AhSREQapVb5AAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouji.png
// module id = wYZK
// module chunks = 1